import { render } from "./StarRatingInput.vue?vue&type=template&id=70345b22&scoped=true"
import script from "./StarRatingInput.vue?vue&type=script&lang=js"
export * from "./StarRatingInput.vue?vue&type=script&lang=js"

import "./StarRatingInput.vue?vue&type=style&index=0&id=70345b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70345b22"]])

export default __exports__